export * from './types';
export * from './tax.reducer';

import tax from './tax.reducer';

export default tax;
